import React, { useState } from "react";
import type { NewsletterSignupBlock } from "@/types/content";
import { useLocalizedTexts, t } from "@/utils/translations";
import styles from "./NewsletterSignup.module.css";

export interface NewsletterSignupProps {
  block: NewsletterSignupBlock;
}

export const NewsletterSignup: React.FC<NewsletterSignupProps> = ({
  block,
}) => {
  const localizedTexts = useLocalizedTexts();
  const [email, setEmail] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Implement newsletter signup API
  };

  return (
    <div className={styles.container} data-component="newsletter-signup">
      <form className={styles.form} onSubmit={handleSubmit}>
        <input
          type="email"
          className={styles.input}
          placeholder={
            block.placeholder ||
            t(
              localizedTexts,
              "Tracker.Newsletter.EmailPlaceholder",
              "Enter your email"
            )
          }
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" className={styles.button}>
          {block.buttonText ||
            t(localizedTexts, "Tracker.Newsletter.SignUp", "Sign up")}
        </button>
      </form>
      {block.disclaimerText && (
        <p className={styles.disclaimer}>{block.disclaimerText}</p>
      )}
    </div>
  );
};

export default NewsletterSignup;
